import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";
import App from './App';
import './index.css';

document.documentElement.style.cssText += ";height:100%!important;overflow:hidden!important;margin:0!important;";
document.body.style.cssText += ";height:100%!important;overflow:hidden!important;margin:0!important;padding:0!important;";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);